var lastScrollTop = 0;
var lastScrollDir = 0;
var upgradeLoading = false;
var triggerCustomCartDataLoading = false;

function CustomReset() {
	document.querySelector(".cart-button-checkout-text")?.classList.remove("hide");
	document.querySelector(".cart-button-checkout-spinner")?.classList.add("hide");
}

function CustomListen() {
	document.querySelectorAll("button.secondary.qty-plus").forEach((item) => {
		item.addEventListener("click", function (e) {
			document.querySelectorAll(".quantity-controls button.qty-plus:not(.secondary)").forEach((_i) => {
				_i.click();
			});
		});
	});

	document.querySelectorAll("button.secondary.qty-minus").forEach((item) => {
		item.addEventListener("click", function (e) {
			document.querySelectorAll(".quantity-controls button.qty-minus:not(.secondary)").forEach((_i) => {
				_i.click();
			});
		});
	});
}

function ImageAndDetailSwitch(event, sectionId, desktopImage, mobileImage) {  
  $(`#${sectionId} details:not(#${$(event).attr('id')})`).removeAttr('open');
  setTimeout(() => {
    $(`#${sectionId} details#${$(event).attr('id')}:not([open])`).attr('open', true);
  }, 10);
  if (desktopImage != '') {
    $(`#${sectionId} .desktop-image`).attr('src',desktopImage);
  }
  if (mobileImage != '') {
    $(`#${sectionId} .mobile-image`).attr('src',mobileImage);
  }
}

function SwatchChange(event, value, productId) {
	event.preventDefault();
	event.stopPropagation();

	const card = `#product_card_${productId}`;
	const imageStr = $(`${card} label[data-value="${value}"][data-option="Color"]`).attr("data-images");
	const images = imageStr.split(",");
	const firstImage = images[0];
	$(`${card} .p-img`).attr("src", firstImage);
}

function CustomQuantityWatcher() {
	$("#custom_quantity_decrease").on("click", () => {
		var cur = $("#custom_quantity_count").val();
		var _new = Number.parseInt(cur) - 1;
		if (_new <= 0) _new = 1;
		$("#custom_quantity_count_display").text(_new);
		$("#custom_quantity_count").val(_new);
		$("#quantity").val(_new);

		recalcPrice(_new);
	});
	$("#custom_quantity_increase").on("click", () => {
		var cur = $("#custom_quantity_count").val();
		var _new = Number.parseInt(cur) + 1;
		if (_new >= 10) _new = 9;
		$("#custom_quantity_count_display").text(_new);
		$("#custom_quantity_count").val(_new);
		$("#quantity").val(_new);

		recalcPrice(_new);
	});
}

setTimeout(() => {
  CustomQuantityWatcher();  
}, 1000);

function CustomQuantityChanged(variant_id, e, main_price, var_price) {
	window.product.CompareAtPrice = `${getCurrencySymbol()}${var_price / 100}`;
	if (main_price == var_price) window.product.CompareAtPrice = `${getCurrencySymbol()}0.00`;
	var x = document.getElementsByClassName(e.target.className);
	for (var i = 0; i < x.length; i++) {
		x[i].checked = true;
	}
	window.product.Price = `${getCurrencySymbol()}${main_price / 100}`;
	//window.product.CompareAtPrice = "£0.00";
	custom_variant_change(variant_id);
}

function recalcPrice(newVal) {
	if (typeof window.product === "undefined" || window.product == null) return;
	var bp = parseFloat(window.product.price.toString().replace(getCurrencySymbol(), ""));
	var newPrice = (bp * newVal) / 100;
	var quant = document.getElementsByClassName("quantity-selector");
	for (var i = 0; i < quant.length; i++) {
		quant[i].value = newVal;
	}
	var ptu = document.getElementsByClassName("update_price_field");
	for (var i = 0; i < ptu.length; i++) {
		ptu[i].innerHTML = `<span class="money">${getCurrencySymbol()}${newPrice.toFixed(2)}</span>`;
	}

	var cptu = document.querySelectorAll(".compare-at-price.js");
	for (var i = 0; i < cptu.length; i++) {
		cptu[i].innerHTML = `<span class="money"></span>`;
	}

	if (window.product.compare_at_price == null || window.product.compare_at_price == "£0.00") {
		var cptu = document.querySelectorAll(".compare-at-price.js");
		for (var i = 0; i < cptu.length; i++) {
			cptu[i].innerHTML = `<span class="money"></span>`;
		}
	} else {
		var compAtPrice = parseFloat(window.product.compare_at_price.replace(getCurrencySymbol(), ""));
		var newCompPrice = compAtPrice * newVal;
		var cptu = document.querySelectorAll(".compare-at-price.js");
		for (var i = 0; i < cptu.length; i++) {
			cptu[i].innerHTML = `<span class="money">${getCurrencySymbol()}${newCompPrice.toFixed(2)}</span>`;
		}
	}
}

function DisplayPrice(newPrice, newCompPrice, quantity = 1) {
	newPrice *= quantity;

	var ptu = document.getElementsByClassName("update_price_field");
	for (var i = 0; i < ptu.length; i++) {
		ptu[i].innerHTML = `<span class="money">${getCurrencySymbol()}${newPrice.toFixed(2)}</span>`;
	}

	if (newCompPrice == undefined || newCompPrice.toString().endsWith("0.00") || newCompPrice.toString() == newPrice.toString() || newCompPrice == 000) {
		var cptu = document.querySelectorAll(".compare-at-price.js");
		for (var i = 0; i < cptu.length; i++) {
			cptu[i].innerHTML = `<span class="money"></span>`;
		}
	} else {
		var cptu = document.querySelectorAll(".compare-at-price.js");
		for (var i = 0; i < cptu.length; i++) {
			cptu[i].innerHTML = `<span class="money">${getCurrencySymbol()}${newCompPrice.toFixed(2)}</span>`;
		}
	}

	let savingHtml = document.querySelectorAll('.product__saving');

	if (newCompPrice > newPrice && savingHtml) {
		let savingValue = newCompPrice - newPrice;
		savingHtml.forEach(item =>{
			item.innerHTML = `${getCurrencySymbol()}${savingValue.toFixed(2)}`
		})
	}
}

function getCurrencySymbol() {
	const locale = window.Shopify.locale;
	const currency = window.Shopify.currency.active;
	return (0)
		.toLocaleString(locale, {
			style: "currency",
			currency: currency,
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		})
		.replace(/\d/g, "")
		.trim();
}

function custom_variant_change(variant_id) {
	/* ADD SOLD OUT SUPPORT? */
	var qtyInput = document.getElementById("quantity");
	var val = parseInt(qtyInput.value.toString(), 10);

	var variantInput = document.getElementById("product_id");
	variantInput.value = variant_id;

	recalcPrice(val);
}

CustomListen();
CustomReset();
window.onload = function () {
	ConfigureWhitebox();
};

/// WHITEBOX
function ConfigureWhitebox() {
	console.log("configure whitebox...");
	// $("#custom_whitebox").on("click", (e) => {
	// 	e.stopPropagation();
	// 	CloseWhitebox();
	// });

	$("#whitebox_close").on("click", (e) => {
		e.stopPropagation();
		CloseWhitebox();
	});
}

function WhitboxSwitch(event) {
	const checked = $(event.target).is(":checked");
	if (checked) {
		$("#whitebox_image").attr("src", window.whiteboxImages[0]);
	} else {
		$("#whitebox_image").attr("src", window.whiteboxImages[1]);
	}
}

function CloseWhitebox() {
	window.whiteboxImages = [];
	$("#custom_whitebox").hide();
	$("#whitebox_image").attr("src", "");
	UnlockScroll();
}

function OpenWhiteboxImage(imageSource) {
	$("#whitebox_image").attr("src", imageSource);
	$("#custom_whitebox").show();
	LockScroll();
}

function OpenMultiWhiteboxImage(imageSources) {
    console.log('open wb', imageSources);
	window.whiteboxImages = imageSources;
	$("#whitebox_image").attr("src", window.whiteboxImages[0]);
	$("#custom_whitebox").show();
	LockScroll();
}

function LockScroll() {
	var y = -scrollY;
	$("html").addClass("whitebox-open");
	$(".whitebox-open body").css("top", y);
}

function UnlockScroll() {
	var y = Number.parseFloat($(".whitebox-open body").css("top"));
	y = y * -1;
	$(".whitebox-open body").css("top", null);
	$("html").removeClass("whitebox-open");
	window.scrollTo({ top: y, left: 0, behavior: "instant" });
	setTimeout(() => {
		window.scrollTo({ top: y, left: 0, behavior: "instant" });
	}, 10);
}
///





